import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import OrganizationDashboard from './pages/organization-dashboard';
import AccountSettings from './pages/account-settings';
import UserManagement from './pages/user-management';
import LoginAuthentication from './pages/login-authentication';
import SharingManagement from './pages/sharing-management';
import VaultManagement from './pages/vault-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AccountSettings />} />
        <Route path="/organization-dashboard" element={<OrganizationDashboard />} />
        <Route path="/account-settings" element={<AccountSettings />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/login-authentication" element={<LoginAuthentication />} />
        <Route path="/sharing-management" element={<SharingManagement />} />
        <Route path="/vault-management" element={<VaultManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
